const middleware = {}

middleware['authenticated'] = require('../middleware/authenticated.ts')
middleware['authenticated'] = middleware['authenticated'].default || middleware['authenticated']

middleware['close-modals'] = require('../middleware/close-modals.ts')
middleware['close-modals'] = middleware['close-modals'].default || middleware['close-modals']

middleware['fetch-articles'] = require('../middleware/fetch-articles.ts')
middleware['fetch-articles'] = middleware['fetch-articles'].default || middleware['fetch-articles']

middleware['mobile-menu'] = require('../middleware/mobile-menu.ts')
middleware['mobile-menu'] = middleware['mobile-menu'].default || middleware['mobile-menu']

middleware['productfilter'] = require('../middleware/productfilter.ts')
middleware['productfilter'] = middleware['productfilter'].default || middleware['productfilter']

export default middleware
